var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNextAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 23,
    viewBox: "0 0 15 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.7557 0.391739C2.30306 -0.13058 3.1905 -0.130581 3.73785 0.391739L14.1691 10.3458C14.1878 10.3637 14.2058 10.3819 14.2233 10.4004L14.5895 10.7499C15.1368 11.2722 15.1368 12.1191 14.5895 12.6414L4.1449 22.6083C3.59754 23.1306 2.71011 23.1306 2.16274 22.6083L0.817656 21.3246C0.270192 20.8023 0.270192 19.9554 0.817656 19.4331L8.9275 11.6942L0.410493 3.56684C-0.13683 3.04453 -0.13683 2.19767 0.410493 1.67536L1.7557 0.391739Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextAction);
export default __webpack_public_path__ + "static/media/NextAction.9c1973b7dd67ebd92a059efb199915b0.svg";
export { ForwardRef as ReactComponent };